<template>
  <div class="home">
    <b-container>
      <h1>SysJudge</h1>
      <p style="text-align: center">自動化線上解題系統</p>
    </b-container>
  </div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: "Home",
  //components: {
  //  HelloWorld
  // }
  
  created() {
    if (this.$route.query.token != undefined) {
      localStorage.setItem("access_token", this.$route.query.token);
      location.replace("/");
    }
    //let privateKey = wireguard.generatePrivateKey();
    //let publicKey = wireguard.generatePublicKey(privateKey);
  },
};
</script>
